import type { AsyncState } from '../../../platform/async/Async'
import type { Txn } from '../../transactions/transactionWire'
import type { TxnPage } from '../../transactions/useTransactions'

export const RECENT_ROWS = 5

/**
 * M6's first page as the widget's rows: the first five in the server's order.
 * The hook returns `success` for a zero-total page (whether that is "nothing
 * yet" or "nothing matches" depends on filters, and there are none here), so
 * empty is decided here. Fetching the default page and slicing is display, not
 * arithmetic.
 */
export function toRecentState(state: AsyncState<TxnPage>): AsyncState<Txn[]> {
  if (state.status !== 'success' && state.status !== 'stale') return state
  return state.data.rows.length === 0 ? { status: 'empty' } : { status: 'success', data: state.data.rows.slice(0, RECENT_ROWS) }
}
